import GameState from "slotworks/model/game-state";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class HasScatterWins extends Decision {
    public evaluate() {
        const gameplay = GameState.getCurrentGame();
        const record = gameplay.getCurrentRecord();

        return record.getResultsOfType(ScatterResult).length > 0 ? Exit.True : Exit.False;
    }
}
